import { ClosedReason } from '../enums.mjs';

const REASONS_REQUIRING_NOTE = new Set([ClosedReason.other]);
function validateCloseRequiredFields(val, ctx) {
    if (!val.closedReason || !REASONS_REQUIRING_NOTE.has(val.closedReason))
        return;
    if (!val.note?.trim()) {
        ctx.addIssue({
            code: "custom",
            message: "Note is required when reason is Other",
            input: val,
            path: ["note"],
        });
    }
}

export { validateCloseRequiredFields };
